(function ($) {

	$(function () {
    /** =============================================
     *  UP AND DOWN SCROLLER
     *  ============================================= */

    var pagePositon = -1,
    sectionsSelector = '.scrollto-section',
    $scrollItems = $(sectionsSelector),
    offsetTolerance = 30,
    pageMaxPosition = $scrollItems.length - 1

    function changeScrollerDir(dir) {
      var scrollerAngle = $('.scroller i')

      if (dir == 'down') {
        if (scrollerAngle.hasClass('fa-angle-up')) {
          scrollerAngle.removeClass('fa-angle-up')
        }
        if (!scrollerAngle.hasClass('fa-angle-down')) {
          scrollerAngle.addClass('fa-angle-down')
        }
      }
      if (dir == 'up') {
        if (scrollerAngle.hasClass('fa-angle-down')) {
          scrollerAngle.removeClass('fa-angle-down')
        }
        if (!scrollerAngle.hasClass('fa-angle-up')) {
          scrollerAngle.addClass('fa-angle-up')
        }
      }
    }

    initScroller()

    // Bind to scroll
    $(window).bind('scroll', updatePosition)

    //Move on click:
    $('.scroller').click(function(e) {
      //if the scroller is pointing upwards, scroll to the top of the page
      if ($(this).children('.fa-angle-up').length > 0) {
        $('html, body')
          .stop()
          .animate({ scrollTop: 0 }, 1500)
        setTimeout(function() {
          pagePositon = -1
          changeScrollerDir('down')
        }, 1500)
      } else {
        //else scroll to the next scrollitem
        $('html, body')
          .stop()
          .animate(
            {
              scrollTop: $scrollItems.eq(++pagePositon).offset().top,
            },
            1500
          )

        setTimeout(function() {
          var scrollHeight = $(document).height()
          var scrollPosition = $(window).height() + $(window).scrollTop()
          if ((scrollHeight - scrollPosition) / scrollHeight === 0) {
            changeScrollerDir('up')
          }
        }, 1500)
      }
    })

    //Update position func:
    function updatePosition() {
      var fromTop = $(this).scrollTop()
      var $cur = null
      $scrollItems.each(function(index, ele) {
        if ($(ele).offset().top < fromTop + offsetTolerance) $cur = $(ele)
      })

      if ($cur != null && pagePositon != $cur.data('pos')) {
        if ($cur.data('pos') == 0) {
          pagePositon = -1
        } else {
          pagePositon = $cur.data('pos')
        }

        //if we have reached the last scrollitem or is near to the bottom of the page, make the scroller point upwards
        if (pagePositon == pageMaxPosition) {
          changeScrollerDir('up')
        } else {
          //else make it point downwards
          changeScrollerDir('down')
        }
      }
    }

    $('.js-open-about').on('click', function() {
      $('.js-about-wrapper').addClass('open')
      $(this).remove()
    })

    /** =============================================
     *  TILE SLIDER THING - ON FRONT PAGE
     *  ============================================= */

    function slickInit() {
      $('.js-tile-slider').each(function(index, value) {
        $(this).slick({
          arrows: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          prevArrow: $('.tile-slider-arrow--left', $(this).parent()),
          nextArrow: $('.tile-slider-arrow--right', $(this).parent()),
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        })

        $(this).on('afterChange', function(event, slick, currentSlide) {
          var $currentSection = $(this).parents('.slider-section')
          var $currentNavPills = $currentSection.find('.nav-pills')
          var $activeNavPill = $currentSection.find('.nav-link.active')
          var $activeNavPillParent = $activeNavPill.parent()
          var $activeNavPillIndex = $activeNavPillParent.index()
          var $newActivePillParent = null

          //Balra
          if (currentSlide == 0 && !slick.animating) {
            event.preventDefault()

            if ($activeNavPillParent.is(':first-child')) {
              $newActivePillParent = $currentNavPills.children().last()
              $newActivePillParent.find('.nav-link').tab('show')
            } else {
              $newActivePillParent = $currentNavPills
                .children()
                .eq($activeNavPillIndex - 1)
              $newActivePillParent.find('.nav-link').tab('show')
            }
          }

          //Jobbra
          if (
            currentSlide >= slick.slideCount - slick.options.slidesToShow &&
            !slick.animating
          ) {
            event.preventDefault()
            if ($activeNavPillParent.is(':last-child')) {
              $newActivePillParent = $currentNavPills.children().first()
              $newActivePillParent.find('.nav-link').tab('show')
            } else {
              $newActivePillParent = $currentNavPills
                .children()
                .eq($activeNavPillIndex + 1)
              $newActivePillParent.find('.nav-link').tab('show')
            }
          }

          //Scroll anim
          if (!slick.animating) {
            var $newActivePillParentIndex = $newActivePillParent.index()

            $currentSection.find('.nav-pills.js-scrollable').animate(
              {
                scrollLeft:
                  $newActivePillParent.outerWidth() * $newActivePillParentIndex,
              },
              0
            )
          }
        })
      })
    }

    slickInit()

    $('a[data-toggle="pill"]').on('shown.bs.tab', function(e) {
      $('.js-tile-slider').slick('slickGoTo', 0, true)
      $('.js-tile-slider').slick('setPosition')

      var $currentSection = $(this).parents('.slider-section')
      if ($currentSection.length) {
        var $that = $(this)
        $currentSection.find('.nav-pills.js-scrollable').animate(
          {
            scrollLeft: $that.outerWidth() * $that.parent().index(),
          },
          200
        )
      }

      $('.match-h-slider').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
      })
    })

    if ($(window).width() > 768) {
      $('.match-h').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
      })
      $('.match-h-buttons').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
      })
    }

    $('.match-h-always').matchHeight({
      byRow: false,
      property: 'height',
      target: null,
      remove: false,
    })

    $('.match-h-buttons-always').matchHeight({
      byRow: false,
      property: 'height',
      target: null,
      remove: false,
    })

    $('.match-h-slider').matchHeight({
      byRow: true,
      property: 'height',
      target: null,
      remove: false,
    })

    /** =============================================
     *  NEWS SLIDER THING - ON FRONT PAGE
     *  ============================================= */

    $('.news-slider').slick({
      autoplay: true,
      speed: 1200,
      slidesToScroll: 1,
      slidesToShow: 4,
      autoplaySpeed: 8000,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 993,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
          },
        },
      ],
    })

    /** =============================================
     *  PROJECTS SLIDER THING - ON FRONT PAGE
     *  ============================================= */

    $('.projects-slider').slick({
      autoplay: true,
      speed: 1200,
      slidesToScroll: 1,
      slidesToShow: 4,
      autoplaySpeed: 8000,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 993,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
          },
        },
      ],
    })

    /** =============================================
     *  FRONT PAGE DIGIT COUNTING ANIMATION
     *  ============================================= */

    if ($('.front-page').length > 0) {
      let hasStarted = false;
    
      $(window).scroll(startCounter);
    
      function startCounter() {
        // Ellenőrizzük, hogy a '.details' elem létezik-e, mielőtt folytatjuk
        if ($('.details').length === 0) {
          console.warn("The '.details' element does not exist.");
          return;
        }
    
        var offset = $(window).width() <= 768 ? 0 : 500;
        var pageBottom = $(window).scrollTop() + $(window).height();
        var elementTop = $('.details').offset().top + offset;
    
        if (pageBottom > elementTop && !hasStarted) {
          hasStarted = true;
    
          $('.number-to-anim').each(function () {
            var $this = $(this);
            if ($this.hasClass('duringanim')) return;
    
            var fullText = $this.text().trim();
            var matches = fullText.match(/^(\d+\.?\d*)(.*)/);
    
            if (!matches) {
              console.warn(`No valid number format found in: "${fullText}"`);
              return;
            }
    
            var number = parseFloat(matches[1]);
            var suffix = matches[2] || '';
    
            $this.addClass('duringanim');
    
            $({ Counter: 0 }).animate(
              {
                Counter: number,
              },
              {
                duration: 3000,
                easing: 'swing',
                step: function (now) {
                  // 'now' az aktuális animációs érték
                  var current = now;
                  if ($this.hasClass('fraction')) {
                    var formatted = current.toFixed(1);
                    if (formatted.endsWith('.0')) {
                      formatted = formatted.slice(0, -2);
                    }
                    $this.text(formatted + suffix);
                  } else {
                    $this.text(Math.ceil(current) + suffix);
                  }
                },
                complete: function () {
                  $this.text(number + suffix);
                  $this.removeClass('duringanim');
                },
              }
            );
          });
        }
      }
    
      // Ellenőrizzük az elemet kezdetben is, ha már látható
      startCounter();
    }
    
    
  })
})(jQuery);
